const getProportionalRadius = (
  quantity,
  minQ,
  maxQ,
  minRadius = 10,
  maxRadius = 50,
) => {
  if (maxQ === minQ) return minRadius
  return (
    minRadius + ((quantity - minQ) * (maxRadius - minRadius)) / (maxQ - minQ)
  )
}

export default getProportionalRadius
